// Visible text lives in src/i18n/locales/<lang>/*.json. This file keeps only
// non-text data: images, links and the floating-word list.

export const introdata = {
  image: "/media/alina-portrait.jpg",
};

export const contactInfo = {
  email: "zelinskayaalinaig@gmail.com",
  linkedin: "https://www.linkedin.com/in/alina-zelinska-60317a281/",
  instagram: "https://www.instagram.com/alin.a.zelinska/",
  tiktok: "https://www.tiktok.com/@movalina.study",
  // Verified reviews and lesson history (the source of the 5.0 rating)
  italki: "https://www.italki.com/en/teacher/13251889?lv=1",
};

// Words that drift through the home page hero, grouped into themes that take turns.
// Ukrainian, a romanisation (also the gloss key in widgets.json), and English.
export const floatingWordThemes = {
  love: [
    { uk: 'Любов', tr: 'liubov', en: 'love' },
    { uk: 'Кохання', tr: 'kokhannia', en: 'romantic love' },
    { uk: 'Серце', tr: 'sertse', en: 'heart' },
    { uk: 'Душа', tr: 'dusha', en: 'soul' },
    { uk: 'Тепло', tr: 'teplo', en: 'warmth' },
    { uk: 'Ніжність', tr: 'nizhnist', en: 'tenderness' },
    { uk: 'Поцілунок', tr: 'potsilunok', en: 'kiss' },
    { uk: 'Обійми', tr: 'obiimy', en: 'hug' },
    { uk: 'Кохана', tr: 'kokhana', en: 'beloved' },
    { uk: 'Разом', tr: 'razom', en: 'together' },
    { uk: 'Вірність', tr: 'virnist', en: 'faithfulness' },
    { uk: 'Мрія', tr: 'mriia', en: 'dream' },
    { uk: 'Щастя', tr: 'shchastia', en: 'happiness' },
    { uk: 'Надія', tr: 'nadiia', en: 'hope' },
    { uk: 'Квітка', tr: 'kvitka', en: 'flower' },
  ],
  ukraine: [
    { uk: 'Україна', tr: 'ukraina', en: 'Ukraine' },
    { uk: 'Воля', tr: 'volia', en: 'freedom' },
    { uk: 'Соняшник', tr: 'soniashnyk', en: 'sunflower' },
    { uk: 'Калина', tr: 'kalyna', en: 'guelder rose' },
    { uk: 'Вишня', tr: 'vyshnia', en: 'cherry' },
    { uk: 'Пшениця', tr: 'pshenytsia', en: 'wheat' },
    { uk: 'Вишиванка', tr: 'vyshyvanka', en: 'embroidered shirt' },
    { uk: 'Борщ', tr: 'borshch', en: 'borscht' },
    { uk: 'Степ', tr: 'step', en: 'steppe' },
    { uk: 'Дніпро', tr: 'dnipro', en: 'the Dnipro river' },
    { uk: 'Київ', tr: 'kyiv', en: 'Kyiv' },
    { uk: 'Барвінок', tr: 'barvinok', en: 'periwinkle' },
    { uk: 'Батьківщина', tr: 'batkivshchyna', en: 'homeland' },
    { uk: 'Слава', tr: 'slava', en: 'glory' },
    { uk: 'Домівка', tr: 'domivka', en: 'home' },
    { uk: 'Небо', tr: 'nebo', en: 'sky' },
  ],
  languages: [
    { uk: 'Мова', tr: 'mova', en: 'language' },
    { uk: 'Слово', tr: 'slovo', en: 'word' },
    { uk: 'Привіт', tr: 'pryvit', en: 'hello' },
    { uk: 'Дякую', tr: 'diakuiu', en: 'thank you' },
    { uk: 'Будь ласка', tr: 'bud laska', en: 'please' },
    { uk: 'Алфавіт', tr: 'alfavit', en: 'alphabet' },
    { uk: 'Книга', tr: 'knyha', en: 'book' },
    { uk: 'Поезія', tr: 'poeziia', en: 'poetry' },
    { uk: 'Лист', tr: 'lyst', en: 'letter' },
    { uk: 'Голос', tr: 'holos', en: 'voice' },
    { uk: 'Розмова', tr: 'rozmova', en: 'conversation' },
    { uk: 'Переклад', tr: 'pereklad', en: 'translation' },
    { uk: 'Урок', tr: 'urok', en: 'lesson' },
    { uk: 'Питання', tr: 'pytannia', en: 'question' },
    { uk: 'Відповідь', tr: 'vidpovid', en: 'answer' },
    { uk: 'Натхнення', tr: 'natkhnennia', en: 'inspiration' },
  ],
  travel: [
    { uk: 'Подорож', tr: 'podorozh', en: 'journey' },
    { uk: 'Дорога', tr: 'doroha', en: 'road' },
    { uk: 'Потяг', tr: 'potiah', en: 'train' },
    { uk: 'Літак', tr: 'litak', en: 'plane' },
    { uk: 'Валіза', tr: 'valiza', en: 'suitcase' },
    { uk: 'Квиток', tr: 'kvytok', en: 'ticket' },
    { uk: 'Карта', tr: 'karta', en: 'map' },
    { uk: 'Місто', tr: 'misto', en: 'city' },
    { uk: 'Море', tr: 'more', en: 'sea' },
    { uk: 'Гора', tr: 'hora', en: 'mountain' },
    { uk: 'Ріка', tr: 'rika', en: 'river' },
    { uk: 'Океан', tr: 'okean', en: 'ocean' },
    { uk: 'Світ', tr: 'svit', en: 'world' },
    { uk: 'Сонце', tr: 'sontse', en: 'sun' },
    { uk: 'Зірка', tr: 'zirka', en: 'star' },
    { uk: 'Кава', tr: 'kava', en: 'coffee' },
  ],
};
